import { useModal, useToast} from "@/comn/hooks";
import { useRecoilState } from "recoil";
import { resetPasswordFormState } from "../recoil";
import {api} from "@/comn";
import {useLogin} from "@/comn/features/authentication/useLogin";
import {useTranslation} from "react-i18next";

export const useChangePassword = () => {
    const {showToast} = useToast();
    const {logout}    = useLogin();
    const {t}         = useTranslation();
    const modal       = useModal();
    const [changePasswordForm, setChangePasswordForm] = useRecoilState(resetPasswordFormState);

    const handleSubmitChange = async (event: any) => {
        event.preventDefault();
        
        try {

            const { usrId, ...rest } = changePasswordForm;

            const caseMap: any = {
                  tancis : { url: "/api/v1/ptli/mypage/myinfo/chgpwd"          , payload: {cstmOfcrNo    : usrId, ...rest}}
                , tanesw : { url: "/api/v1/ptle/extptl/mypage/myinfochg/chgpwd", payload: {xtrnUsrIdntfNo: usrId, ...rest}}
            }

            const key      = process.env.REACT_APP_SYSTEM_GROUP == "tanoga" ? "tanesw" : process.env.REACT_APP_SYSTEM_GROUP || "";
            const base     = process.env.REACT_APP_SYSTEM_GROUP == "tancis" ? process.env.REACT_APP_API_PTLI : process.env.REACT_APP_API_PTLE;
            const response = await api.post( base + caseMap[key].url, caseMap[key].payload);

            response.status == 201 &&
            modal.openModal({ content: t("msg.ptl.00798"), onClose: () => logout()
            });

        } catch (error:any) {
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    const handleSubmitChangeSkip = async (event: any) => {
        event.preventDefault();

        try {

            const caseMap: any = {
                  tancis : { url: "/api/v1/ptli/mypage/myinfo/chgSkipPwd" }
                , tanesw : { url: "/api/v1/ptle/extptl/mypage/myinfochg/chgSkipPwd" }
            }

            const key     = process.env.REACT_APP_SYSTEM_GROUP == "tanoga" ? "tanesw" : process.env.REACT_APP_SYSTEM_GROUP || "";
            const base    = process.env.REACT_APP_SYSTEM_GROUP == "tancis" ? process.env.REACT_APP_API_PTLI : process.env.REACT_APP_API_PTLE;

            const response = await api.post( base + caseMap[key].url, caseMap[key].payload);

            response.status == 201 && ( window.location.href = window.location.origin + (process.env.REACT_APP_BASE || "") );

        } catch (error:any) {
            console.log(error);
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    return {
        changePasswordForm,
        setChangePasswordForm,
        handleSubmitChange,
        handleSubmitChangeSkip,
    };
};
